import React from 'react';

import { useIntl, FormattedMessage } from 'react-intl';
import { scrollToRef } from '../../../../utils';

import { useFelaEnhanced } from '@ackee/fela';
import Text, { TextTypes } from '../../Text';
import { MessageKey } from 'modules/intl';

import * as felaRules from './NavigationItem.rules';


type NavigationItemProps = {
    reference: React.RefObject<HTMLElement>;
    isLast: boolean;
    title: string;
    active: boolean;
    itemsVisible: boolean;
}


const NavigationItem = ({  reference, isLast, title, active, itemsVisible }: NavigationItemProps) => {
    const { styles, rules } = useFelaEnhanced(felaRules, { active, itemsVisible });

    const handleClick = () => {
        scrollToRef(reference);
    };
    
    const { formatMessage } = useIntl();

    const label = formatMessage({ id: 'sectionNavigation.button.aria.label' });
    const buttonName = formatMessage({ id: title as MessageKey });

    return (
        <>
            <div
                onClick={handleClick}
                role="button"
                aria-label={label}
                onKeyDown={handleClick}
                tabIndex={0}
                className={styles.container}
            >
                <div className={styles.buttonContainer} role="button" aria-label={buttonName} tabIndex={0}>
                    <div className={styles.inner} />
                </div>
                {/* @ts-expect-error */}
                <Text itemsVisible={itemsVisible} extend={{ text: rules.extendText }} active={active} type={TextTypes.SECTION}>
                    <FormattedMessage id={title as MessageKey} />
                </Text>
            </div>
            {!isLast && <div className={styles.divider} />}
        </>
    );
};


export default NavigationItem;
